import { tabsAnatomy as v } from "@chakra-ui/anatomy";
import { cssVar as c, createMultiStyleConfigHelpers as f, defineStyle as i } from "@chakra-ui/styled-system";
import { getColor as d } from "@chakra-ui/theme-tools";
const e = c("tabs-color"), t = c("tabs-bg"), n = c("tabs-border-color"), { defineMultiStyleConfig: p, definePartsStyle: a } = f(v.keys), g = i((r) => {
  const { orientation: o } = r;
  return {
    display: o === "vertical" ? "flex" : "block"
  };
}), h = i((r) => {
  const { isFitted: o } = r;
  return {
    flex: o ? 1 : void 0,
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
      zIndex: 1,
      boxShadow: "outline"
    },
    _disabled: {
      cursor: "not-allowed",
      opacity: 0.4
    }
  };
}), u = i((r) => {
  const { align: o = "start", orientation: l } = r;
  return {
    justifyContent: {
      end: "flex-end",
      center: "center",
      start: "flex-start"
    }[o],
    flexDirection: l === "vertical" ? "column" : "row"
  };
}), y = i({
  p: 4
}), x = a((r) => ({
  root: g(r),
  tab: h(r),
  tablist: u(r),
  tabpanel: y
})), S = {
  sm: a({
    tab: {
      fontSize: "sm",
      lineHeight: "5",
      py: 2,
      px: 4
    }
  }),
  md: a({
    tab: {
      fontSize: "xl",
      lineHeight: "7",
      py: 2,
      px: 4
    }
  })
}, C = a((r) => {
  const { colorScheme: o, orientation: l } = r, s = l === "vertical", b = s ? "borderStart" : "borderBottom", m = s ? "marginStart" : "marginBottom";
  return {
    tablist: {
      [b]: "2px solid",
      borderColor: "inherit"
    },
    tab: {
      [b]: "2px solid",
      borderColor: "transparent",
      [m]: "-2px",
      fontWeight: "bold",
      [e.variable]: "colors.coldGray.300",
      _selected: {
        [e.variable]: "colors.".concat(o, ".500"),
        _dark: {
          [e.variable]: "colors.".concat(o, ".300")
        },
        borderColor: "currentColor",
        fontWeight: "bold"
      },
      _active: {
        [t.variable]: "colors.gray.100",
        _dark: {
          [t.variable]: "colors.whiteAlpha.300"
        }
      },
      _disabled: {
        _active: { bg: "none" }
      },
      color: e.reference,
      bg: t.reference
    }
  };
}), _ = a((r) => {
  const { colorScheme: o } = r;
  return {
    tab: {
      borderTopRadius: "md",
      border: "1px solid",
      borderColor: "transparent",
      mb: "-1px",
      [n.variable]: "transparent",
      _selected: {
        [e.variable]: "colors.".concat(o, ".600"),
        [n.variable]: "colors.white",
        _dark: {
          [e.variable]: "colors.".concat(o, ".300"),
          [n.variable]: "colors.gray.800"
        },
        borderColor: "inherit",
        borderBottomColor: n.reference
      },
      color: e.reference
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}), $ = a((r) => {
  const { colorScheme: o } = r;
  return {
    tab: {
      border: "1px solid",
      borderColor: "inherit",
      [t.variable]: "colors.gray.50",
      _dark: {
        [t.variable]: "colors.whiteAlpha.50"
      },
      mb: "-1px",
      _notLast: {
        marginEnd: "-1px"
      },
      _selected: {
        [t.variable]: "colors.white",
        [e.variable]: "colors.".concat(o, ".600"),
        _dark: {
          [t.variable]: "colors.gray.800",
          [e.variable]: "colors.".concat(o, ".300")
        },
        borderColor: "inherit",
        borderTopColor: "currentColor",
        borderBottomColor: "transparent"
      },
      color: e.reference,
      bg: t.reference
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}), k = a((r) => {
  const { colorScheme: o, theme: l } = r;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      color: "gray.600",
      _selected: {
        color: d(l, "".concat(o, ".700")),
        bg: d(l, "".concat(o, ".100"))
      }
    }
  };
}), w = a((r) => {
  const { colorScheme: o } = r;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      [e.variable]: "colors.gray.600",
      _dark: {
        [e.variable]: "inherit"
      },
      _selected: {
        [e.variable]: "colors.white",
        [t.variable]: "colors.".concat(o, ".600"),
        _dark: {
          [e.variable]: "colors.gray.800",
          [t.variable]: "colors.".concat(o, ".300")
        }
      },
      color: e.reference,
      bg: t.reference
    }
  };
}), B = a({}), R = {
  line: C,
  enclosed: _,
  "enclosed-colored": $,
  "soft-rounded": k,
  "solid-rounded": w,
  unstyled: B
}, W = p({
  baseStyle: x,
  sizes: S,
  variants: R,
  defaultProps: {
    size: "sm",
    variant: "line",
    colorScheme: "indigo"
  }
});
export {
  W as tabsTheme
};
